import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { DriverService } from '../../services/driver/driver.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-address-details-form',
  templateUrl: './address-details-form.component.html',
  styleUrls: ['./address-details-form.component.scss']
})
export class AddressDetailsFormComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() requiredFieldObject: any = {
    PostalCode: false,
    Country: false,
    State: false,
    City: false,
    Landmark: false,
    Street: false
  };
  @Input() isFormSubmit: boolean;
  @Output() modifiedValueOutput = new EventEmitter<any>();
  isSearch: boolean = false;
  unitNo: any;
  floor: any;
  flat: any;
  landmark: any;
  address: any;
  Pincode: any;
  country: any;
  state: any;
  city: any;
  street: any;
  postalCode: any;
  constructor(private driverService: DriverService, private translate: TranslateService) { }

  ngOnInit() {
    this.initalizeForm();
  }

  initalizeForm() {
    // 
    this.unitNo = {
      lable: "User.UnitNo",
      dataField: 'UnitNo',
      formControlName: 'UnitNo',
      //   isRequired: this.requiredFieldObject.Street,
      placeholder: "User.EnterUnitNo",
    };
    this.floor = {
      lable: "Floor",
      dataField: 'FloorNo',
      formControlName: 'FloorNo',
      //   isRequired: this.requiredFieldObject.Street,
      placeholder: "Enter Floor",
    };
    this.flat = {
      lable: "Flat",
      dataField: 'FlatNo',
      formControlName: 'FlatNo',
      //   isRequired: this.requiredFieldObject.Street,
      placeholder: "Enter Flat",
    };
    this.landmark = {
      lable: "User.landmark",
      dataField: 'LandMark',
      formControlName: 'LandMark',
      //    isRequired: this.requiredFieldObject.Landmark,
      placeholder: "User.EnterLandmark",
    };
    this.address = {
      lable: "User.Address",
      dataField: 'Address',
      formControlName: 'Address',
      //   isRequired: this.requiredFieldObject.Street,
      placeholder: "User.EnterStreet",
    };
    this.postalCode = {
      lable: "User.Pincode",
      dataField: 'PostalCode',
      formControlName: 'PostalCode',
      //  isRequired: this.requiredFieldObject.PostalCode,
      placeholder: "User.SelectPincode",
      isSearch: false
    };
    this.country = {
      lable: "User.Country",
      dataField: 'Country',
      formControlName: 'Country',
      //  isRequired: this.requiredFieldObject.Country,
      placeholder: "User.SelectCountry",
      isSearch: false
    };
    this.state = {
      lable: "User.State",
      dataField: 'State',
      formControlName: 'State',
      // isReadOnly: true,
      //    isRequired: this.requiredFieldObject.State,
      placeholder: "User.EnterState",
      isSearch: false
    };
    this.city = {
      lable: "User.City",
      dataField: 'City',
      formControlName: 'City',
      // isReadOnly: true,
      //  isRequired: this.requiredFieldObject.City,
      placeholder: "User.City",
      isSearch: false
    };
    // this.street = {
    //   lable: "User.Address",
    //   dataField: 'Street',
    //   formControlName: 'Street',
    //   //   isRequired: this.requiredFieldObject.Street,
    //   placeholder: "User.EnterStreet",
    // };
  }

  ngOnChanges(changes: SimpleChanges): void {
    const data: SimpleChange = changes.data && changes.data.currentValue;
    // this.readonlyStateChange();

    // if (data && this.data.Id && (this.data[this.pincode.dataField] || this.data.Pincode)
    //   && (this.data[this.country.dataField])
    //   && (this.data[this.state.dataField])
    //   && (this.data[this.city.dataField])) {
    //   const pincode = this.data[this.pincode.dataField];
    //   const country = this.data[this.country.dataField];
    //   const state = this.data[this.state.dataField];
    //   const city = this.data[this.city.dataField];
    //   this.data.PostalCode = pincode;
    //   pincode && this.getAddressDetails(pincode);
    //   country && this.getCountryDetails(country, 'Country', null, 'country');
    //   state && this.getCountryDetails(state, 'State', this.data[this.country.dataField], 'state');
    //   city && this.getCountryDetails(city, 'City', this.data[this.city.dataField], 'city');
    //   this.readonlyStateChange();
    // }
  }

  getChangedValue(value, dataField) {

    if (dataField === 'Country' || dataField === 'City' ||
      dataField === 'PostalCode' || dataField === 'State') {
      this.data[dataField] = value.value;
      if (dataField === 'PostalCode') {
        const addressDetails = value
        this.data.City = addressDetails.CityName;
        this.data.Country = addressDetails.CountryName;
        this.data.State = addressDetails.StateName;
      }
    } else {
      this.data[dataField] = value;
    }
    this.modifiedValueOutput.emit({ value, dataField });
    this.readonlyStateChange();
  }

  readonlyStateChange() {
    if (this.data) {
      this.state.isReadOnly = this.data[this.country.dataField] ? false : true;
      this.city.isReadOnly = this.data[this.state.dataField] ? false : true;
    }
  }

  getAddressDetails(searchedKey) {
    this.isSearch = true;
    this.driverService.getAdressDetailByPostcode(searchedKey).then((x: any[]) => {
      x = x.slice(0, 50);
      this.postalCode = { ...this.postalCode, dropdownList: x };
      this.isSearch = false;
    }).catch((error) => {
      this.isSearch = false;
    })
  }

  getCountryDetails(searchedKey, categoryName, parentId = null, objName) {
    this[objName].isSearch = true;
    this.driverService.getCountryDetailByPostcode(searchedKey, categoryName, parentId).then((x: any[]) => {
      x = x.slice(0, 50);
      this[objName] = { ...this[objName], dropdownList: x };
      this[objName].isSearch = false;
    }).catch((error) => {
      this[objName].isSearch = false;
    })
  }

}
